export default "__VITE_ASSET__B3kcHrGx__"